/* eslint-disable max-lines-per-function */
import React from "react";
import { Box } from "@material-ui/core";
import { Input } from "components/haven-design/form/inputs";
import { FieldType } from "../fields";
import styles from "./format.module.css";

interface FormatProps {
  format: FieldType | null;
  value: string | null;
  onChange: (value: string) => void;
}

interface TextFormatProps {
  placeholder: string;
}

const TextFormat: React.FC<TextFormatProps & FormatProps> = (props) => (
  <input
    placeholder={props.placeholder}
    onChange={(event) => props.onChange(event.target.value)}
    value={props.value || ""}
  />
);

const Format: React.FC<FormatProps> = (props) => {
  const [isSpecialFormat, toggleSpecial] = React.useState(false);

  const changeHandler: (event: { target: {value: string}}) => void = (event) => {
    if (event.target.value === "custom") {
      toggleSpecial(true);
      props.onChange("");
      return;
    }

    props.onChange(event.target.value);
  };

  const renderSpecialFormat = (placeholder: string) => (
    <div className={styles.special}>
      <TextFormat {...props} placeholder={placeholder} />
      <div className={styles.controls}>
        <a
          className={styles.close}
          onClick={(event) => {
            event.preventDefault();
            toggleSpecial(false);
          }}
        >
          Close
        </a>
      </div>
    </div>
  );

  switch (props.format) {
    case "date_with_format": {
      const value = isSpecialFormat ? "custom" : props.value || "";
      if (isSpecialFormat) {
        return renderSpecialFormat("MM/DD/YYYY");
      }

      return (
        <select onChange={changeHandler} value={value}>
          <option value="" />
          <option value="MM/DD/YYYY">05/24/1975</option>
          <option value="MM/DD/YY">05/24/75</option>
          <option value="MM/D/YYYY">05/6/1975</option>
          <option value="MM/D/YY">05/6/75</option>
          <option value="M/DD/YYYY">5/06/1975</option>
          <option value="M/DD/YY">5/06/75</option>
          <option value="M/D/YYYY">5/6/1975</option>
          <option value="M/D/YY">5/6/75</option>
          <option value="custom">Custom</option>
        </select>
      );
    }

    case "time_with_format": {
      const value = isSpecialFormat ? "custom" : props.value || "";
      if (isSpecialFormat) {
        return renderSpecialFormat("h:mm A");
      }

      return (
        <select onChange={changeHandler} value={value}>
          <option value="" />
          <option value="h:mm A">9:23 PM</option>
          <option value="h:mm a">9:23 pm</option>
          <option value="h:mmA">9:23PM</option>
          <option value="h:mma">9:23pm</option>
          <option value="hh:mm A">09:23 PM</option>
          <option value="hh:mm a">09:23 pm</option>
          <option value="hh:mm:ss A">09:23:00 PM</option>
          <option value="hh:mm:ss a">09:23:00 pm</option>
          <option value="h:mm:ss A">9:23:00 PM</option>
          <option value="h:mm:ss a">9:23:00 pm</option>
          <option value="custom">Custom</option>
        </select>
      );
    }

    case "append_note":
      return (
        <Box sx={{ alignSelf: "center", mt: 1 }}>
          <Input
            name="note"
            onChange={changeHandler}
            placeholder="(Example) Moved into unit number: "
            type="text"
            value={props.value || ""}
          />
        </Box>
      );

    default:
      return null;
  }
};

export default Format;
